// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"445":"3fe53fb0","494":"e02f31c8","809":"7e2d8106","814":"ad5c0320","859":"086360da"}[chunkId] + ".css";
};